import React, { createContext } from 'react';
import mapper from '../modules/mapper';
import storage from '../modules/storage';
import configMap from './config.map.json';
import { WEBSITE_BASE_URL, EXTENSION_CONTENT_PATH, WIDGET_CONTENT_PATH } from '../config/consts';

export const StateContext = createContext();
const FETCH_INTERVAL = 10 * 60 * 1000;

class StateProvider extends React.Component {
	state = {
		loaded: false,
		// current: null,
		data: {},
		topGames: [],
		categories: [],
		featured: [],
		feedbackLink: null,
		favorites: []
	};

	fetchData() {
		return new Promise(async resolve => {
			let lastFetchTime = await storage.get('lastFetchTime');
			let result;
			if (parseInt(lastFetchTime) + FETCH_INTERVAL > new Date())
				result = JSON.parse(await storage.get('cachedResponse'));
			else
				result = await fetch(`${WEBSITE_BASE_URL + EXTENSION_CONTENT_PATH}`)
					.then(res => res.json())
					.then(async res => {
						await storage.set({
							'lastFetchTime': new Date().getTime(),
							'cachedResponse': JSON.stringify(res)
						});
						return res;
					})
					.catch(async er =>
						JSON.parse((await storage.get('cachedResponse')) || '{ "data" : { "content" : [] } }')
					);
			resolve(result);
		});
	}

	getWidgetConfig() {
		return new Promise(async resolve => {
			let lastFetchTime = await storage.get('lastConfigFetchTime');
			let result;
			if (parseInt(lastFetchTime) + FETCH_INTERVAL > new Date())
				result = JSON.parse(await storage.get('cachedConfig'));
			else
				result = await fetch(`${WEBSITE_BASE_URL + WIDGET_CONTENT_PATH}`)
					.then(res => res.json())
					.then(response => {
						return mapper.map(response, configMap);
					})
					.then(async res => {
						await storage.set({
							'lastConfigFetchTime': new Date().getTime(),
							'cachedConfig': JSON.stringify(res)
					});
						return res;
					})
					.catch(async er =>
						JSON.parse(
							(await storage.get('cachedConfig')) ||
								'{ "data" : { "feedbackLink" : "https://airtable.com/shrZDXg66rFFORqO4" } }'
						)
					);

			resolve(result);
		});
	}

	// getGameById(data, id) {
	// 	return data.find(game => game.id == id);
	// }

	// setLastGame(game) {
	// 	if (game) {
	// 		localStorage.setItem('lastGame', JSON.stringify(game));
	// 	} else {
	// 		localStorage.removeItem('lastGame');
	// 	}
	// }

	setFavorite(id, add = true) {
		if (id) {
			let newFavorites = add ? this.state.favorites.concat([id]) : this.state.favorites.filter(fav => fav !== id);
			if (add) {
				this.setState({
					favorites: newFavorites
				});
				this.state.data.content.find(game => {
					if (game.id === id) {
						game.categories.push('Favorites');
						return game;
					}
					return null;
				});
			} else {
				this.setState({
					favorites: newFavorites
				});
				this.state.data.content.find(game => {
					if (game.id === id) {
						game.categories = game.categories.filter(ctg => ctg !== 'Favorites');
						return game;
					}
					return null;
				});
			}
			storage.set({'favorites': JSON.stringify(newFavorites)});
		}
	}

	// getCurrentGame(data) {
	// 	const firstRun = !await storage.get('firstRun');
	// 	const lpContentId = data?.info?.lpContentId;
	// 	const lastGame = await storage.get('lastGame');

	// 	if (firstRun && lpContentId) {
	// 		return this.getGameById(data.content, lpContentId);
	// 	} else if (lastGame) {
	// 		return JSON.parse(lastGame);
	// 	}
	// 	return null;
	// }

	async getFavorites() {
		const favorites = await storage.get('favorites');
		if (!favorites) return [];
		return JSON.parse(favorites);
	}

	filterData(data) {
		const categories = new Set();
		const topGames = [];
		const featured = [];
		const other = [];

		data.content.forEach(game => {
			game.categories.forEach(category => {
				if (category !== 'Other') {
					categories.add(category);
				} else {
					other.push(game);
				}
			});

			if (featured.length < 12 && Math.random() > 0.8) {
				featured.push(game);
			}

			if (+game.rating >= 90) {
				game.categories.push('Top Games');
				topGames.push(game);
			}
		});

		return { categories, topGames, featured, other };
	}

	setup() {
		this.fetchData().then(async res => {
			let { categories, topGames, featured, other } = this.filterData(res.data);
			categories = Array.from(categories).sort();
			categories = [...categories, 'Other'];

			// const current = this.getCurrentGame(res.data);
			const favorites = await this.getFavorites();
			let data = res.data;

			favorites.forEach(id => {
				data.content.find(game => {
					if (game.id === id) {
						game.categories?.push('Favorites');
						return game;
					}
					return null;
				});
			});

			// if (current) {
			// 	this.setLastGame(current);
			// }

			this.setState({
				loaded: true,
				data,
				// current,
				topGames,
				categories,
				// featured,
				favorites
				// other
			});
		});

		this.getWidgetConfig().then(response => {
			this.setState(state => {
				return {
					...state,
					feedbackLink: response?.feedbackLink
				};
			});
		});
	}

	// setCurrent(current) {
	// 	this.setState(oldState => ({ ...oldState, current }));
	// 	this.setLastGame(current);
	// }

	componentDidMount() {
		this.setup();
	}

	render() {
		return (
			<StateContext.Provider
				value={{
					data: this.state,
					// setCurrent: this.setCurrent.bind(this),
					setFavorite: this.setFavorite.bind(this)
				}}
			>
				{this.props.children}
			</StateContext.Provider>
		);
	}
}

export default StateProvider;
